import React from 'react';
import { FullScreenSpinner } from '@guryou/html-components';
import { stateIsLoaded, stateIsLoading, useClass } from '@guryou/redux';
import { useOnboardContext } from 'onboard/context';

import CourseSessions from './CourseSessions';

const ClassLoader = () => {
  const { createdCourseIds } = useOnboardContext();
  // const createdCourseIds = { serviceId: 1183, classId: 2342 };
  const { gyClass, ...rest } = useClass(createdCourseIds || {});

  if (!stateIsLoaded(rest) || stateIsLoading(rest)) {
    return <FullScreenSpinner />;
  }

  return <CourseSessions gyClass={gyClass} />;
};

export default ClassLoader;
